import { render, staticRenderFns } from "./SiderNavGuild.vue?vue&type=template&id=b0249bac&scoped=true"
import script from "./SiderNavGuild.vue?vue&type=script&lang=js"
export * from "./SiderNavGuild.vue?vue&type=script&lang=js"
import style0 from "./SiderNavGuild.vue?vue&type=style&index=0&id=b0249bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0249bac",
  null
  
)

export default component.exports